import {
  TooltipArrow,
  TooltipContent,
  TooltipPopup,
} from '@melements/front-components/dist/components/tooltip/Tooltip.styles';
import LogoutHoverSvg from 'assets/icons/exit-hover.svg';
import LogoutSvg from 'assets/icons/exit.svg';
import TooltipArrowSvg from 'assets/icons/tooltip-arrow.svg';
import Avatar from 'assets/icons/user.svg';
import styled, { to } from 'theme';

export const UserAvatar = styled.div`
  margin: -0.375rem 0;
  width: 3.75rem;
  height: 3.75rem;
  background-image: url(${Avatar});
  background-color: rgba(0, 136, 202, 0.16);
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 50%;
  cursor: pointer;

  ${to('lg')} {
    width: 2.5rem;
    height: 2.5rem;
  }
`;

export const DropdownContainer = styled.div`
  width: 17.0625rem;
  background-color: ${props => props.theme.variables.colors.white};
  position: relative;

  ${to('lg')} {
    width: 100vw;
  }
`;

export const DropdownHeader = styled.div`
  background-color: ${props => props.theme.variables.customColors.lightBlue};
  padding: 1.1875rem;
  border-radius: 0.25rem 0.25rem 0 0;
  display: flex;
  flex-direction: row;
  align-items: baseline;
`;

export const User = styled.div`
  font-family: ${props => props.theme.variables.typography.secondaryFont};
  font-size: ${props => props.theme.variables.fonts.size.bigger1};
  font-weight: ${props => props.theme.variables.fonts.weight.bold};
  color: ${props => props.theme.variables.colors.white};
  margin-right: 1rem;
`;

export const UserRole = styled.div`
  font-family: ${props => props.theme.variables.typography.primaryFont};
  font-size: ${props => props.theme.variables.fonts.size.smaller1};
  font-weight: ${props => props.theme.variables.fonts.weight.bold};
  color: ${props => props.theme.variables.colors.white};
`;

export const DropdownPopup = styled(TooltipPopup)`
  ${to('lg')} {
    width: 100vw;
    position: fixed !important;
    transform: none !important;
    right: 0;
    top: 3.75rem !important;
  }
`;

export const DropdownContent = styled(TooltipContent)`
  background-color: transparent;
  padding: 0;
  box-shadow: 0 0.25rem 1rem 0 rgba(0, 0, 0, 0.2);
`;

export const DropdownArrow = styled(TooltipArrow)`
  background: url(${TooltipArrowSvg});
`;

export const LogoutIcon = styled.div`
  background: url(${LogoutSvg});
  height: 1.6rem;
  width: 1.6rem;
`;

export const Logout = styled.div`
  color: ${props => props.theme.variables.customColors.leadingColor.base};
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  &:hover {
    color: ${props => props.theme.variables.customColors.leadingColor.mid};
  }
`;

export const DropdownElement = styled.span`
  height: 3rem;
  width: 100%;
  color: ${props => props.theme.variables.customColors.lightBlue};
  padding: 0 1.1875rem;
  align-items: center;
  display: flex;
  font-family: ${props => props.theme.variables.typography.secondaryFont};
  font-size: ${props => props.theme.variables.fonts.size.bigger1};
  font-weight: ${props => props.theme.variables.fonts.weight.medium};

  &:hover {
    color: ${props => props.theme.variables.customColors.lightNavy};

    ${Logout} {
      color: ${props => props.theme.variables.customColors.leadingColor.mid};
    }

    ${LogoutIcon} {
      background: url(${LogoutHoverSvg});
    }
  }
`;
